import model from '../models-v2/crm/crm-partner';
import routeName from './route-name';

export default [
  {
    path: '/crm-partners/create',
    name: routeName.crmPartner.store,
    component: () => import('../pages/crm-partner/CrmPartnerCreateView.vue'),
  },
  {
    path: '/crm-partners/edit/:id(\\d+)',
    name: routeName.crmPartner.edit,
    component: () => import('../pages/crm-partner/CrmPartnerEditView.vue'),
  },
  {
    path: '/crm-partners',
    name: routeName.crmPartner.index,
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../views/pages/crm-partner/CrmPartnerTopRightSection.vue'),
    },
    meta: {
      // acl: AclName.SettingsPageTemplatesKhTemplatesList,
      breadcrumb: [
        { title: 'Wspólnicy', url: '/crm-partners' },
        { title: 'Lista', url: '/crm-partners' },
      ],
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
